import styled from 'styled-components'
const Quote = styled.div`
  padding-top: 60px;
  font-family: var(--font-serif);
  font-size: 30px;
  line-height: 1.2em;
  font-weight: 700;
  width: 100%;
  text-align: center;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
`

export const Persons = {
  meretgrob: {
    name: (
      <>
        Eine davon ist <b>Meret Grob</b>.
      </>
    ),
    age: 28,
    position: 'Stadtparlament Wil (SG)',
    since: 'Januar 2021',
    party: 'Junge Grüne',
    img: require('../../images/MeretGrob.jpg'),

    pointselector: {
      levels: 'levels.3.gemeinde',
      gender: 'gender.1.f',
      assault: 'assault.1',
    },
    text: (
      <>
        <p>
          <b>
            Ein Mann rief mich an und sagte, er arbeite für eine Krankenkasse.
            Er wolle bei mir zu Hause vorbeikommen. Ich merkte rasch, dass das
            nicht stimmt, sagte Nein. Und wieder Nein.
          </b>{' '}
          Doch er liess nicht locker. Ich erwähnte die Polizei. Er antwortete,
          das sei ihm egal. Da bekam ich Panik. Es war eine bedrohliche
          Situation – auch weil ich während des Telefons merkte: Die Adressen
          von uns Wiler Parlamentarierinnen und Parlamentariern sind ja allesamt
          öffentlich. Der weiss wirklich, wo ich wohne. Muss nur meinen Namen
          googeln und kann einfach so bei mir auftauchen.
        </p>
        <p>
          Es war anders als die Mails, die ich schon erhalten habe. Näher.
          Persönlicher. Man merkt ja irgendwie, wenn jemand es ernst meint.
          Einem droht.
        </p>
        <p>
          Als er schliesslich aufhängte, rief ich sofort die Wiler
          Stadtschreiberin an, bat sie, so rasch als möglich meine Kontaktdaten
          – insbesondere meine Privatadresse – vom Internet zu nehmen. Sie
          machte das sofort – doch ich fühlte mich immer noch unwohl. Für
          ziemlich lange. Ich dachte: Jeder, nicht nur dieser Mann, irgendjemand
          kann bei dir zu Hause auftauchen. Jetzt. Jederzeit. Und ich kann
          nichts dagegen machen. Diese Hilflosigkeit, dieses Ohnmachtsgefühl war
          neu. Auch wenn die Vernunft einem sagt, es wird nichts passieren –
          dein Gefühl sagt dir etwas anderes.
        </p>
        <p>
          Nach dem Vorfall informierte ich die Polizei, doch die Nummer des
          Anrufers war ihr nicht bekannt. Sie sagte, sie könne höchstens etwas
          öfter bei meinem Haus patrouillieren. Auf eine Anzeige verzichtete
          ich, ich bin Juristin und weiss, wie es bei diesen Straftatbeständen
          gegen unbekannt ist: schwierig.
        </p>
        <p>
          Heute, ein gutes halbes Jahr später, macht mir der Vorfall keine Angst
          mehr.
        </p>
      </>
    ),
  },
  baptistehurni: {
    name: (
      <>
        Einer davon ist
        <br />
        <b>Baptiste Hurni</b>.
      </>
    ),
    age: 37,
    position: 'Nationalrat (NE)',
    since: 'Dezember 2019',
    party: 'SP',
    img: require('../../images/BaptisteHurni.jpg'),
    pointselector: {
      levels: 'levels.3.gemeinde',
      offenderType: 'offenderType.2.buerger',
      injuryCause: 'injuryCause.3.gender',
    },
    text: (
      <>
        <p>
          <b>
            Die meisten verbalen Attacken auf mich finden online statt. «Eine
            Neun-Millimeter-Kugel ist schnell abgefeuert», schrieb einmal einer
            unter ein Bild von mir auf Facebook. Das ist quasi eine Morddrohung.
          </b>{' '}
          Ich meldete sie. Zum Glück haben wir auf Stufe National- und Ständerat
          dafür eine Stelle, die solche Vorfälle dem Bundesamt für Polizei
          (Fedpol) meldet. Die Menschen fühlen sich anonym im Netz. Haben das
          Gefühl, sie könnten alles schreiben.
        </p>
        <p>
          Als richtig bedrohlich schätzte ich die Situation erst einmal ein. Ein
          Mann klingelte wütend bei mir an der Haustür. Doch ich war nicht da.
          Meine Frau öffnete – sie war damals im achten Monat schwanger. Das hat
          mich dann doch sehr beschäftigt.
        </p>
        <p>
          Der Mann zielte auf meine Rolle als Vizepräsident des Dachverbandes
          Schweizerischer Patientenstellen. Ich habe ihm anscheinend auf eine
          Mail nicht geantwortet. Das tue ich sonst eigentlich immer. Mir
          gefällt die Nähe, die wir in der Schweiz zwischen Politikern und
          Bürgerinnen haben.
        </p>
        <p>
          Meine Frau hat gut reagiert. Sie sagte dem Unbekannten, dass sie
          nichts mit meiner Politik zu tun habe. Und gab ihm meine Büroadresse.
          Mich informierte sie per Telefon. Als er prompt in meinem Büro
          auftauchte, sagte ich meinen Mitarbeitenden, dass sie ihn nicht
          reinlassen sollen. Wenn er nicht gehe, würden wir die Polizei rufen.
          Zum Glück verschwand er wieder. Später erfuhr ich vom Fedpol, dass er
          psychische Probleme und bereits mehrfach Anzeigen wegen gewalttätigem
          Verhalten hatte. Das lässt einen schon sehr nachdenklich zurück.
        </p>
        <p>
          Trotzdem: Ich wollte keine Anzeige einreichen. Und ich wollte auch
          bisher nie damit an die Medien. Und plane es auch in Zukunft nicht
          mehr. Mir geht es um Politik. Für sie soll man mich kennen. Nur hat
          mir dieser Vorfall gezeigt, dass es leider eine gewisse Distanz
          zwischen Bürgern und Politikern braucht. Das finde ich extrem schade.
          Über dieses Problem müssen wir reden.
        </p>
      </>
    ),
  },
  priskaseilergraf: {
    name: (
      <>
        Eine davon ist
        <br />
        <b>Priska Seiler Graf</b>.
      </>
    ),
    age: 54,
    position: 'Nationalrat (Zürich)',
    since: '2015',
    party: 'SP',
    img: require('../../images/PriskaSeilerGraf.jpg'),
    pointselector: {
      levels: 'levels.3.gemeinde',
      offenderType: 'offenderType.2.buerger',
      injuryCause: 'injuryCause.3.gender',
    },
    text: (
      <>
        <p>
          <b>
            Einmal erhielt ich eine dermassen bedrohliche Mail, dass die Polizei
            den Mann in U-Haft nahm. Bei einer Hausdurchsuchung fanden sie bei
            ihm mehrere unregistrierte Waffen. Das macht wirklich Schiss! Aber
            eines kann ich garantieren: Ich lasse mich nicht einschüchtern.
          </b>
        </p>
        <p>
          Ich bin eine Frau. Ich bin links. Und ich äussere mich zu
          Sicherheitsthemen. Voilà!
        </p>
        <p>
          Kommt dazu, dass ich oft Lippenstift trage. Für manche Bürger geht das
          nicht zusammen. Ich gendere jetzt absichtlich nicht. Von 50 Mails, die
          ich bekomme, ist ungefähr eine Mail von einer Frau. Auch in Briefen
          oder in den sozialen Medien muss ich mir beleidigendes Mansplaining
          anhören. Und sehr viele sexistische Kommentare. Viele Männer denken,
          nur weil sie vor 30 Jahren mal einen WK besucht haben, könnten sie
          mich belehren. Ich habe einige Kommentare mal meinen männlichen
          Ratskollegen gezeigt – sie waren total schockiert. Mit sexistischen
          Beleidigungen müssen sie selten umgehen.
        </p>
        <p>
          Ich setzte mich freiwillig der Öffentlichkeit aus. Aber meine Familie
          tut das nicht. Ich erstatte immer Anzeige, wenn mir im Zusammenhang
          mit meiner Familie gedroht wird. Wenn mir ein Mann schreibt: «Ich
          weiss, wo Ihre Kinder zur Schule gehen», reagiere ich umgehend. Solche
          Drohungen bekam ich schon mehrmals.
        </p>
        <p>
          Ich kann mit Kritik umgehen. Sie gehört dazu. Wenn jemand in einem
          anständigen Ton schreibt, schreibe ich immer zurück. Immer. Und meine
          Latte dafür, was anständig ist, liegt wirklich tief. Aber es macht
          manchmal schon etwas mit mir. Es ist so viel Hass da, so viel
          Frustration. 99 Mails berühren mich nicht – ich rege mich eher auf.
          Doch die eine Mail, die letzte, trifft mich eben doch. Zum Glück
          werden wir auf Stufe Bund für diese Angriffe sensibilisiert. Wir haben
          eine Stelle, an die wir uns wenden können. Auf Kantonsebene ist das
          leider nicht überall so. Das ist ein riesiges Manko.
        </p>
      </>
    ),
  },
  verastiffler: {
    name: 'Vera Stiffler',
    age: 49,
    position: 'Grossrätin Graubünden',
    since: '2010',
    party: 'FDP',
    img: require('../../images/VeraStiffler.png'),
    pointselector: {
      levels: 'levels.3.gemeinde',
      offenderType: 'offenderType.2.buerger',
      injuryCause: 'injuryCause.3.gender',
    },
    text: (
      <>
        <p>
          Früher war es im Kanton Graubünden so, dass prestigeträchtige Ämter -
          beispielsweise Verwaltungsratsmandate - unter der Hand vergeben
          wurden, im eigenen Netzwerk. Das störte mich - und das sagte ich auch
          immer im Grossen Rat.
        </p>
        <p>
          Als ich schliesslich vor ein paar Jahren in einen Verwaltungsrat
          gewählt wurde, kam im Parlament ein Kollege zu mir und sagte: “Du bist
          sicher gewählt worden, weil sie eine Frau brauchten!” Ich antwortete:
          “Du kannst jetzt rausgehen, nochmals in den Grossratssaal reinkommen
          und mir sagen: ‘Vera, ich freue mich, dass du gewählt wurdest!’”
        </p>
        <p>
          Ein anderer Grossrat sagte mir, ich hätte das Verwaltungsratsmandat
          nur erhalten, weil ich im Parlament immer kritisiere, dass es in den
          strategischen Gremien zu wenig Frauen habe. Ein Dritter war erstaunt,
          dass ich ein Mandat erhalten habe, das bezahlt sei. Alle diese
          Angriffe deutete ich als Minderwertigkeitskomplex oder Neid. Es tat
          mir fast leid für die Männer, dass sie solche Kommentare machen
          mussten.
        </p>
        <p>
          Mittlerweile bin ich 49 Jahre alt und habe drei Verwaltungsratsmandate
          und ein eigenes Kommunikationsunternehmen. Auch allgemein hat sich die
          Situation verbessert, Mandate und Ämter werden öfters ausgeschrieben -
          transparent für alle einsehbar. Es gibt aber noch viel Luft nach oben.
          In strategischen Gremien sollten gemischte Teams sitzen und
          unabhängige Mitglieder mit relevanten Erfahrungen und mit Fachwissen.
        </p>
        <p>
          Bei den bürgerlichen Parteien hat es nach wie vor zu wenig Frauen: Man
          hat mich in meinen 13 Jahren im Parlament zwar immer wieder ermuntert,
          für Ämter oder Mandate zu kandidieren - doch als es drauf ankam, waren
          viele Männer plötzlich sehr besorgt um mich. Ich hörte oft: “Aber du
          hast doch drei kleine Kinder!” Es interessierte wenig, dass ich mich
          immer schon im Beruf - ich bin seit 10 Jahren selbstständig - und in
          der Politik gemeinsam mit meinem Mann betreffend Kinderbetreuung
          organisiert habe. Das interpretiere ich so: Wenn es um die wirklich
          angesehenen, die wirklich einflussreichen Posten geht, ist es noch
          immer ein Nachteil, wenn man eine Frau ist. Ausser es sind zwei Sitze
          frei oder auf einer Liste der zweite Platz - dann will man gerne eine
          Frau auf dem Ticket.
        </p>
        <p>
          Ich habe in meinen 13 Jahren im Amt gelernt: Geschenkt wird einem
          nichts, geholfen eher selten - ausser man fragt ganz explizit. Bei den
          linken Parteien beobachte ich es bei uns im Kanton anders, da werden
          Frauen eher begleitet und unterstützt.
        </p>
        <p>
          Nichtsdestotrotz ist das Amt als Grossrätin ein sehr spannendes Amt.
          Ich bin gerne Grossrätin und pflege einen freundschaftlichen Austausch
          zu vielen Kolleginnen und Kollegen im Rat.
        </p>
      </>
    ),
  },
  ronahiyener: {
    name: 'Ronahi Yener',
    age: 22,
    position: 'Kantonsrat Zug',
    since: 'Mai 2021',
    party: 'SP',
    img: require('../../images/RonahiYener.png'),
    pointselector: {
      levels: 'levels.3.gemeinde',
      offenderType: 'offenderType.2.buerger',
      injuryCause: 'injuryCause.3.gender',
    },
    text: (
      <>
        <p>
          Zu Beginn meiner Amtszeit musste ich gegen viele Vorurteile ankämpfen
          - zu jung, eine Frau, “nur” Studentin. Dabei arbeite ich nebenher! Es
          ging eine ganze Weile, bis man mir zuhörte. Mich ernst nahm.
          Mittlerweile fühle ich mich recht wohl.
        </p>
        <p>
          Womit ich aber nach wie vor wirklich Mühe habe: die zuweilen
          abfälligen Blicke von gewissen Mitparlamentariern, alles ältere
          Herren. Sie sagen dann Dinge wie: “Nehmen wir die junge Frau doch in
          die Mitte!” Oder sie bevormunden mich, etwa im Zusammenhang mit
          Alkohol - und der wird bei uns im Zuger Kantonsrat ja reichlich
          getrunken, etwa an den Mittagessen zwischen den Parlamentssitzungen.
          Ich hörte schon Sprüche wie: “Hast du nichts gelernt von deiner
          Vorgängerin?” oder “Pass auf dein Glas auf!” Die Anspielungen auf die
          K.O.-Tropfen und die ehemalige Kantonsrätin Jolanda Spiess-Hegglin
          sind mehr als deutlich. Extrem unangenehm. Auch weil jeweils viele
          Parlamentarier daneben sitzen - und keiner etwas sagt. Viel lieber
          lachen sie mit.
        </p>
        <p>
          Im Kantonsparlament muss ich mir auch immer wieder abfällige oder
          herablassende Kommentare anhören, die auf die Herkunft meiner Eltern
          beziehen. Sie stammen aus der Türkei. Es sind Schubladisierungen wie
          etwa: “Trinkst du wegen deiner Religion keinen Alkohol?” oder
          “Erlauben dir das deine Eltern nicht?”
        </p>
        <p>
          Ein körperlicher Vorfall ereignete sich letztes Jahr am
          Parlamentarierturnier - da nehmen jeweils alle Kantonsparlamente der
          Schweiz teil, auch wir Zugerinnen und Zuger waren dabei. Ein
          Kantonsrat, der mich im Parlament des Öfteren angestarrt und
          sexistische Kommentare gemacht hatte, berührte mich auf dem
          Fussballfeld mehrfach, obwohl das vom Spiel her gar nicht nötig war.
          Dann packte er mich von hinten - völlig unvorbereitet. Doch niemand
          aus der Mannschaft sagte etwas. Er hatte das Gefühl, er könne und
          dürfe das tun. Später, am Abend, machte er sich körperlich an
          Parlamentarierinnen aus anderen Kantonen ran. Alle merkten das.
        </p>
        <p>
          Im Vergleich zum Beginn meiner Amtszeit haben die sexistischen und
          rassistischen Kommentare mittlerweile etwas nachgelassen. Habe ich
          mich daran gewöhnt? Oder habe ich mir mehr Respekt erarbeitet -
          insbesondere durch meine Wahl? Ich bin ja nachgerückt für einen
          Parteikollegen, der überraschend zurücktrat, und wurde dann im Amt
          bestätigt. Schwierig zu sagen. Es ist wohl eine Mischung aus beidem.
          Was sicher auch hilft, ist, dass es seit den letzten Wahlen mehr Junge
          im Parlament hat. Ich bin zwar immer noch die Jüngste, aber
          mittlerweile sind wir zu dritt unter 25. Deshalb hoffe ich, dass sich
          die Atmosphäre nun zunehmend verbessert. Weil es anstrengend ist, so
          politisieren zu müssen.
        </p>
      </>
    ),
  },
  djamelbourbala: {
    name: (
      <>
        Einer davon ist
        <br />
        <b>Djamel Bourbala</b>.
      </>
    ),
    age: 59,
    position: 'Gemeinderat Versoix (GE)',
    since: '2022',
    party: 'Die Mitte',
    img: require('../../images/DjamelBourbala.jpg'),
    pointselector: {
      levels: 'levels.3.gemeinde',
      offenderType: 'offenderType.2.buerger',
      injuryCause: 'injuryCause.3.gender',
    },
    text: (
      <>
        <p>
          <b>
            Die Schweiz ist meine Heimat. Ich liebe sie. Aber: Sie liebt mich
            nicht.
          </b>{' '}
          Ich höre fast täglich rassistische Aussagen, spüre die Diskriminierung
          – nicht zuletzt von Parteikollegen. Ja, ich bin Algerier. Aber ich bin
          auch Schweizer. Es ist das Land, das mich aufgenommen hat, das mich
          zum Menschen geformt hat, der ich heute bin. Und ich kenne die
          hiesigen Institutionen wohl besser als so mancher gebürtige Schweizer.
        </p>
        <p>
          Ich kandidierte zweimal für den Gemeinderat in Versoix: 2015 und 2020.
          Ich rückte schliesslich 2022 ins Amt nach. Bei einer Kandidatur 2018
          für die nächsthöhere Ebene, den Genfer Kantonsrat, sagte mir ein
          Parteikollege: Wenn ich reelle Chancen haben wolle, müsse ich meinen
          Namen ändern. Meinen Vor- und Nachnamen! Gehts noch? Ich bin Djamel.
          Kein Robert oder Richard.
        </p>
        <p>
          Und doch: Bei der jüngsten Wahl im April 2023 für den Kantonsrat wurde
          mein Name 1200-mal auf unserer Die-Mitte-Liste durchgestrichen.
          1200-mal. Das ist mehr als bei allen anderen in meiner Partei – und
          tut sehr weh. Im Parlament sprechen Ratsmitglieder aller Parteien
          häufig von «Arabern», von «Islamisten», von «Terroristen». Alles in
          einem Topf. Stigmatisierung pur.
        </p>
        <p>
          Frustrierend ist: Wenn ich die Personen in konkreten Situationen auf
          ihre rassistischen Aussagen anspreche, sagen sie immer dasselbe:
          «Nein, das habe ich so nicht gemeint.» Immer! Sie wollen es nicht
          wahrhaben. Schon gar nicht darüber reden. Die Diskriminierungen
          behindern mich zweifach, nein, dreifach: Ich sitze im Rollstuhl, ich
          bin Algerier, und ich muss täglich mit diesen Sprüchen umgehen.
          Letzteres erschwert mir das Leben mindestens so sehr wie meine
          Behinderung und meine Herkunft.
        </p>
        <p>
          Ich spüre selbst von Parteikollegen, dass sie oft nur so tun, als ob
          sie sich um Menschen mit Behinderung kümmerten. Sie machen Fotos mit
          mir, zeigen stolz, dass sie mich haben. Wenn es aber um
          behindertenfreundliche Politik geht, will man davon nichts mehr
          wissen.
        </p>
        <p>
          Ich kämpfe weiter. Es ist zentral, dass mehr Menschen mit Behinderung
          und mit ausländischem Namen den Schritt in die Politik wagen. In den
          Parlamenten müssten Menschen wie ich 22 Prozent der Schweizer
          Bevölkerung repräsentieren. Bauern – als Beispiel – hingegen nur 1,5
          Prozent. Sie sind komplett überrepräsentiert.
        </p>
      </>
    ),
  },
  urseggerschwiler: {
    name: (
      <>
        Einer davon ist
        <br />
        <b>Urs Eggerschwiler</b>.
      </>
    ),
    age: 52,
    position: 'Grosser Gemeinderat Spiez (BE)',
    since: '2016',
    party: 'SVP',
    img: require('../../images/UrsEggerschwiler.jpg'),
    pointselector: {
      levels: 'levels.3.gemeinde',
      offenderType: 'offenderType.2.buerger',
      injuryCause: 'injuryCause.3.gender',
    },
    text: (
      <>
        <p>
          <b>
            Umzonungen gehören in Spiez zu den umstrittenen, heiklen Vorlagen.
            Einmal, ich sprach mich für eine Änderung der Bauzone angrenzend an
            ein Naturschutzgebiet aus, warfen mir viele Kritiker Unschönes an
            den Kopf: Ich sei verantwortlich für die Zerstörung der Natur, etwa.
            Oder konkrete Drohungen: Ich bekäme das schon noch zurück. Das war
            neu und erschreckend für mich.
          </b>{' '}
          Besonders krass war, dass Bürger mich auf der Strasse beschimpften. Da
          dachte ich: Was, wenn diese Person jetzt handgreiflich wird?
        </p>
        <p>
          Kritik gehört dazu. Aber die Stimmung im Dorf, in der ganzen
          Gesellschaft, wird tendenziell schon immer gehässiger, unhöflicher.
          Vor allem seit Corona. Da ging etwas kaputt. Das stimmt mich
          nachdenklich: Ich mache das freiwillig – für ein paar Hundert Fränkli
          im Jahr. Man muss wirklich, wie ich, aus Überzeugung Politiker sein
          und sich für die Gemeinde einsetzen wollen.
        </p>
        <p>
          Als SVPler ist man sich zudem einiges gewohnt: Unsere Werbekampagnen –
          wir verschicken sie per Post – werden regelmässig mit sehr derben
          Kraftausdrücken zurückgeschickt, unsere Wahlplakate regelmässig mit
          einem Hitlerschnauz erweitert. Das ist unschön. Die Nazi-Keule wird
          immer häufiger ausgeworfen. Ein Totschlagargument. Wir haben einige
          laute nationale Exponenten in der SVP. Hier in Spiez suchen wir immer
          moderate Lösungen. Doch genau diese nationalen Exponenten prägen die
          öffentliche Wahrnehmung unserer Partei enorm. So denken Bürgerinnen
          und Bürger schnell. «Der ist von der SVP, er schiesst sicher auf
          andere – also kann ich auch auf ihn als Person schiessen.» Damit muss
          man umgehen können. Die Grenze wäre für mich aber klar erreicht, wenn
          auch meine Familie ins Visier geriete. Dann würde ich zur Polizei.
        </p>
      </>
    ),
  },
}
